import { OptionsObject, useSnackbar } from 'notistack'

export interface AlertProps {
    message: React.ReactNode
    options?: OptionsObject
}
const useAlert = () => {
    const { enqueueSnackbar } = useSnackbar()
    return (message: AlertProps['message'], options: AlertProps['options']) =>
        enqueueSnackbar(message, options)
}

export default useAlert
